import qs from 'qs';
import { useQuery } from 'react-query';
import { axios } from 'lib';

const defaultQueryParams = {
  page: 0,
  limit: 100,
  search: '',
  includeInactive: false,
  queryKey: ['consortium-group-suppliers'],
  queryOptions: {},
};

const getConsortiumGroupSuppliers = async (faId, cgId, queryStringParams) => {
  const queryString = qs.stringify({ ...queryStringParams });

  const {
    data: { data, total },
  } = await axios.get(
    `/api/framework_agreements/${faId}/consortium_groups/${cgId}/companies?${queryString}`
  );

  return { suppliers: data, total };
};

export const useConsortiumGroupSuppliers = (faId, cgId, queryParams = {}) => {
  const { queryKey, queryOptions, page, limit, search, includeInactive } = {
    ...defaultQueryParams,
    ...queryParams,
  };

  const queryStringParams = {
    limit,
    search,
    includeinactive: includeInactive,
    offset: page * limit,
  };

  return useQuery([...queryKey], () => getConsortiumGroupSuppliers(faId, cgId, queryStringParams), {
    select: ({ suppliers, total }) => ({ suppliers, total }),
    initialData: {
      suppliers: [],
      total: 0,
    },
    ...queryOptions,
  });
};
